<template>
  <v-app>
    <!-- <hsc-menu-style-white style="height:100%"> -->
    <hsc-menu-style-black style="height:100%">
      <div class="v-system-bar">
        <!-- <div class="toolbar-title" style="color:rgb(220, 60, 0);" > Nitros</div> -->       
        <hsc-menu-style-white v-if="!state.dark">
          <hsc-menu-bar style="border-radius: 0 0 0 0;box-shadow:none;color:inherit;" @contextmenu.native="stopBrowserMenu($event)" >
            <hsc-menu-bar-item label="Database">
              <hsc-menu-item label="Create database" @click="OpenCreateDbDialog()" />
              <hsc-menu-item label="Open database" v-on:click="OpenDbDialog()" />
              <!-- <hsc-menu-item label="Refresh" :disabled="!state.active_db" v-on:click="LoadDbFromServer(state.active_db)" /> -->
              <hsc-menu-item label="Refresh" v-on:click="LoadDbFromServer(state.active_db)" />
              <!-- <hsc-menu-item label="Stop" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="StopDb(state.active_db)" /> -->
              <hsc-menu-item label="Stop" v-if="!state.active_db||state.active_db.run" v-on:click="StopDb(state.active_db)" />
              <!-- <hsc-menu-item label="Start" :disabled="!state.active_db" v-if="!state.active_db||!state.active_db.run" v-on:click="StartDb(state.active_db)" /> -->
              <hsc-menu-item label="Start" v-on:click="StartDb(state.active_db)" />
              <!-- <hsc-menu-item label="Diagram" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="DiagramDb(state.active_db)" /> -->
              <hsc-menu-item label="Backup" v-if="!state.active_db||state.active_db.run" v-on:click="OpenBackupDialog(state.active_db)" />
              <!-- <hsc-menu-item label="Backup" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="OpenBackupDialog(state.active_db)" /> -->
              <hsc-menu-item label="Restore" v-on:click="OpenRestoreDialog(state.active_db)" />
              <!-- <hsc-menu-item label="Restore" :disabled="!state.active_db" v-on:click="OpenRestoreDialog(state.active_db)" /> -->
              <hsc-menu-item label="Delete" v-on:click="DeleteDb(state.active_db)" />
              <!-- <hsc-menu-item label="Delete" :disabled="!state.active_db" v-on:click="DeleteDb(state.active_db)" /> -->
            </hsc-menu-bar-item>
            <hsc-menu-bar-item label="Query">
                <hsc-menu-item label="New query" keybind="ctrl+n" v-on:click="CreateTab" />
                <hsc-menu-item label="Close query" v-on:click="CloseTab(state.active_tab)" />
                <!-- <hsc-menu-item label="Run query" keybind="F5" v-on:click="RunActiveTab" /> -->
                <!-- <hsc-menu-item label="Run query" v-on:keyup.F5="RunActiveTab" /> -->
                <hsc-menu-item label="Open" style="z-index: 20" keybind="ctrl+o" v-on:click="OpenFile()" />
                <hsc-menu-item label="Save" keybind="ctrl+s" v-on:click="SaveActiveTab()" />
            </hsc-menu-bar-item>
            <hsc-menu-bar-item label="Help" :title="state.NBAdmin">
              <hsc-menu-item label="Info" :disabled="!state.active_db" v-on:click="OpenDbInfoDialog(state.active_db)" />
              <hsc-menu-item label="Contacts" v-on:click="OpenDbContactsDialog(state.active_db)" />
              <hsc-menu-item label="Dark" v-on:click="toggleDarkTheme" />
              <!-- <hsc-menu-item label="Documentation" v-on:click="Click('helplnk1')" />
              <a href="https://docs.nitrosbase.com/sql-en.html" id="helplnk1" style="display:none;" target="_NEW" ></a> -->
            </hsc-menu-bar-item>
          </hsc-menu-bar>
        </hsc-menu-style-white>
        <hsc-menu-style-black v-if="state.dark"> 
          <hsc-menu-bar style="border-radius: 0 0 0 0;box-shadow:none;color:inherit;" @contextmenu.native="stopBrowserMenu($event)" >
            <hsc-menu-bar-item label="Database">
              <hsc-menu-item label="Create database" @click="OpenCreateDbDialog()" />
              <hsc-menu-item label="Open database" v-on:click="OpenDbDialog()" />
              <!-- <hsc-menu-item label="Close database" v-on:click="CloseDb(state.active_db)" /> -->
              <hsc-menu-item label="Refresh" :disabled="!state.active_db" v-on:click="LoadDbFromServer(state.active_db)" />
              <hsc-menu-item label="Stop" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="StopDb(state.active_db)" />
              <hsc-menu-item label="Start" :disabled="!state.active_db" v-if="!state.active_db||!state.active_db.run" v-on:click="StartDb(state.active_db,ind)" />
              <!-- <hsc-menu-item label="Diagram" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="DiagramDb(state.active_db)" /> -->
              <hsc-menu-item label="Backup" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="OpenBackupDialog(state.active_db)" />
              <!-- <hsc-menu-item label="Restore" :disabled="!state.active_db" v-if="!state.active_db||state.active_db.run" v-on:click="OpenRestoreDialog(state.active_db)" /> -->
              <hsc-menu-item label="Restore" :disabled="!state.active_db" v-on:click="OpenRestoreDialog(state.active_db)" />
              <hsc-menu-item label="Delete" :disabled="!state.active_db" v-on:click="DeleteDb(state.active_db)" />
              <!-- <hsc-menu-item label="Database info" :disabled="!state.active_db" v-on:click="OpenDbInfoDialog(state.active_db)" /> -->
            </hsc-menu-bar-item>
            <hsc-menu-bar-item label="Query">
                <hsc-menu-item label="New query" keybind="ctrl+n" v-on:click="CreateTab" />
                <hsc-menu-item label="Close query" v-on:click="CloseTab(state.active_tab)" />
                <!-- <hsc-menu-item label="Run query" keybind="F5" v-on:click="RunActiveTab" /> -->
                <!-- <hsc-menu-item label="Run query" v-on:keyup.F5="RunActiveTab" /> -->
                <hsc-menu-item label="Open" style="z-index: 20" keybind="ctrl+o" v-on:click="OpenFile()" />
                <hsc-menu-item label="Save" keybind="ctrl+s" v-on:click="SaveActiveTab()" />
            </hsc-menu-bar-item>
            <hsc-menu-bar-item label="Help" :title="state.NBAdmin">
              <hsc-menu-item label="Info" :disabled="!state.active_db" v-on:click="OpenDbInfoDialog(state.active_db)" />
              <hsc-menu-item label="Contacts" v-on:click="OpenDbContactsDialog(state.active_db)" />
              <hsc-menu-item label="Dark" v-on:click="toggleDarkTheme" />
              <!-- <hsc-menu-item label="Documentation" v-on:click="Click('helplnk1')" />
              <a href="https://docs.nitrosbase.com/sql-en.html" id="helplnk1" style="display:none;" target="_NEW" ></a> -->
            </hsc-menu-bar-item>
          </hsc-menu-bar>
        </hsc-menu-style-black>        
        <!-- <div class="spacer"></div> -->
      </div>
       <div :class="{ 'v-system-bar2d' : state.dark, 'v-system-bar2' : !state.dark }">
        <span>Current database: {{ state.menudb?state.menudb:''}}</span>
        <!-- <button class="searchCmp" @click="viewSearch">
          <svg height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#929292" id="icon-111-search"><path d="M19.4271164,20.4271164 C18.0372495,21.4174803 16.3366522,22 14.5,22 C9.80557939,22 6,18.1944206 6,13.5 C6,8.80557939 9.80557939,5 14.5,5 C19.1944206,5 23,8.80557939 23,13.5 C23,15.8472103 22.0486052,17.9722103 20.5104077,19.5104077 L26.5077736,25.5077736 C26.782828,25.782828 26.7761424,26.2238576 26.5,26.5 C26.2219324,26.7780676 25.7796227,26.7796227 25.5077736,26.5077736 L19.4271164,20.4271164 L19.4271164,20.4271164 Z M14.5,21 C18.6421358,21 22,17.6421358 22,13.5 C22,9.35786417 18.6421358,6 14.5,6 C10.3578642,6 7,9.35786417 7,13.5 C7,17.6421358 10.3578642,21 14.5,21 L14.5,21 Z" id="search"/></g></g>
          </svg>
        </button>
        <Search v-if="search" ref="searchAll" :dbList="state.dblist" :menuList="state.menuList2" @closeSerch="closeS($event)" :id="keySearch" /> -->
        <!-- <button :disabled="loading" v-on:click="RunActiveTab()" class="panelbutton roundbtn play" title="Run"> -->
        <button v-if="!loading" v-on:click="RunActiveTab()" class="panelbutton roundbtn play" title="Run">
        <!-- <button v-if="!loading" v-on:click="testError()" class="panelbutton roundbtn play" title="Run"> -->
          <!-- <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-lightning-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>
              </svg> -->
          <svg  version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="16px" height="16px" viewBox="0 0 779.652 779.652" class="play" style="enable-background:new 0 0 779.652 779.652;"
               xml:space="preserve">
          <g>
          <g id="_x37__12_">
          <g>
          <path d="M679.503,349.728L151.09,9.181C119.742-7.703,83.832-5.951,83.832,54.688v670.58c0,55.408,38.525,64.17,67.258,45.506
                    l528.442-340.547C701.255,407.975,701.255,371.953,679.503,349.728z" />
                </g>
              </g>
            </g>
          </svg>
        </button>
        <button v-if="loading" class="panelbutton roundbtn cancel" @click="cancelRequest" title="stop"><span class="cancelR"></span></button>
        <button v-on:click="CreateTab('','')" class="panelbutton roundbtn" title="Create query">
          <svg width="1em" height="1em" viewBox="2 2 12 12" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z" />
            <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z" />
          </svg>
        </button>
        <!-- v-if="showCancel"  -->
        <!--<div class="d-flex">-->
          <!--<input class="w-33" type="text" v-model="itemShowBegin" style="border: 1px solid #eee; width: 33px" @input="getArr()">
          <input class="w-33" type="text" v-model="itemShowEnd" style="border: 1px solid #eee; width: 33px" @input="getArr()">-->
        <!--</div>-->
      </div>
      <div class="panes-container">
        <splitpanes class="default-theme" vertical @resize="getWidth">
          <pane  min-size="5" size="13">
            <div class="left-pane" ref="menu">
              <LeftMenu ref="leftMenu" v-if="state.dblist" :state="state" :heightS="height" :key="lftM" @update-state="handleStateUpdate"/>         
            </div>
          </pane>
          <pane size="87">
            <div class="right-pane" ref="rightPane">               
              <v-tabs 
                show-arrows 
                style="border-bottom: 2px solid #ddd;"
                v-model="items"                          
              >
                <v-tab 
                  v-for="tab,indx in state.openedtabs" v-bind:key="tab.name"
                  class="d-flex align-center"
                  v-on:click="OpenTab(tab)"
                >
                  <span>{{tab.name}}</span>
                  <v-hover v-slot="{ hover }">
                    <!--<span v-on:click="CloseTab(tab)" class="span-close-tab">✖</span>--> 
                    <v-icon class="ml-2 closeBtn" :class="{ 'on-hover': hover }" v-on:click="CloseTab(tab)">mdi-close</v-icon>
                  </v-hover>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="items">
                <v-tab-item
                  v-for="tab,index in state.openedtabs"
                  :key="tab.name"
                >
                  <query :key="tab.name + index" :dark="state.dark" :tab="tab" :state="state" v-show="tab.active" :style="'height:' + hQuery + 'px;' + 'width:' + wQuery + 'px;'">
                    <!--:style="'height:' + hQuery + 'px'"-->
                  </query>
                </v-tab-item>
              </v-tabs-items>  
            </div>
          </pane>
        </splitpanes>
      </div>
      <modal name="create-database" :clickToClose="false" :height="400">
        <div class="modal-header">
          <h3 class="modal-title">Create database</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div>
              <div class="edit-line">
                <div class="label-for-input">DB name: </div><input v-model="txt1" :class="'form-control create-db' + (txt1_invalid?' is-invalid' :'')">
              </div>
              <div class="edit-line">
                <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
              </div>
              <div class="edit-line">
                <div class="label-for-input">Path: </div><input style="margin-left: 5px; width: calc(100% - 10px);" class="form-control form-control-sm" v-model="txt0" >
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
            <button class="btn btn-primary" v-on:click="CreateDatabase(txt1, txt2, txt0)">Save</button>
          </div>
        </div>
      </modal>
      <modal name="choosePort" :clickToClose="false" :height="250">
        <div class="modal-header">
          <h3 class="modal-title">Port busy, please select another</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
            <!-- CancelCreateDb() -->
            <button class="btn btn-primary" v-on:click="CreateDatabase(txt1, txt2, txt0)">Save</button>
          </div>
        </div>
      </modal>
      <modal name="choosePortStart" :clickToClose="false" :height="250" @before-open="getStartDb">
        <div class="modal-header">
          <h3 class="modal-title">Port busy, please select another</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
            <button class="btn btn-primary" v-on:click="StartDbPort()">Save</button>
          </div>
        </div>
      </modal>
      <modal name="choosePortOpen" :clickToClose="false" :height="250">
        <div class="modal-header">
          <h3 class="modal-title">Port busy, please select another</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog(), LoadDBListFromServer()">Cancel</button>
            <button class="btn btn-primary" v-on:click="OpenDatabase(txt1, txt2, txt3)">Save</button>
          </div>
        </div>
      </modal>
      <modal name="open-database" :clickToClose="false" :height="400">
        <div class="modal-header">
          <h3 class="modal-title">Open database</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div>
              <div class="edit-line">
                <div class="label-for-input">DB name: </div><input v-model="txt1" :class="'form-control create-db' + (txt1_invalid?' is-invalid' :'')">
                <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
                <!-- <div class="label-for-input">Path: </div><input type="file" webkitdirectory :class="'form-control create-db' + (txt3_invalid?' is-invalid' :'')" @change="getpath"> -->
                <div class="label-for-input">Path: </div><input type="text" v-model="txt3" :class="'form-control create-db' + (txt3_invalid?' is-invalid' :'')">
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
            <button class="btn btn-primary" v-on:click="OpenDatabase(txt1, txt2, txt3)">Open</button>
          </div>
        </div>
      </modal>
      <modal name="create-edge" :height="315" :clickToClose="false">
        <div class="modal-header">
          <h3 class="modal-title">Create edge</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edge">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Edge name: </div><input style="width: calc(100% - 10px);" class="createEdge form-control form-control-sm" v-model="txt1" >
              </div>
              <div class="edit-line">
                <!-- <div class="label-for-input">From: </div><v-select v-model="txt3" style="margin-left: 0" :reduce="o => o.tablename" label="tablename" :options="GetTables(state.active_db, 2,7)"></v-select> -->
                <div class="label-for-input">From: </div><v-select v-model="txt3" style="margin-left: 0" :reduce="o => o.tablename" label="tablename" :options="GetTablesVirtual(state.active_db, 2,3)"></v-select>
              </div>
              <div class="edit-line">
                <!-- <div class="label-for-input">To: </div><v-select v-model="txt4" style="margin-left: 0" :reduce="o => o.tablename" label="tablename" :options="GetTables(state.active_db, 2,8)"></v-select> -->
                <div class="label-for-input">To: </div><v-select v-model="txt4" style="margin-left: 0" :reduce="o => o.tablename" label="tablename" :options="GetTablesVirtual(state.active_db, 2,4)"></v-select>
              </div>
            </div>
          </div>
          <div class="buttons">
            <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
            <button class="btn btn-primary" v-on:click="CreateEdge(txt1, txt3, txt4)">Save</button>
          </div>  
        </div>
      </modal>
      <modal name="create-backup" :clickToClose="false">
        <div class="modal-header">
          <h3 class="modal-title">Backup...</h3>
          <button :disabled="backUp" v-on:click="CloseDialog()" title="Close" class="close">×</button>
        </div>
        <div class="modal-body" style="position: relative;">
          <div class="add-edge">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Backup path: </div><input :disabled="backUp" style="margin-left: 5px; width: calc(100% - 10px);" class="form-control form-control-sm" v-model="txt1" >
              </div>
            </div>
          </div>
          <spinner v-if="backUp" class="loadSpinner"></spinner>
          <div class="buttons">
              <button :disabled="backUp" class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
              <button :disabled="backUp" class="btn btn-primary" v-on:click="BackupDb(state.active_db, txt1)">Backup</button>
          </div>
        </div>
      </modal>
      <modal name="create-restore" :clickToClose="false">
        <div class="modal-header">
          <h3 class="modal-title">Restore...</h3>
          <button :disabled="backUp" v-on:click="CloseDialog()" title="Close" class="close">×</button>
        </div>
        <div class="modal-body">
          <div class="add-edge">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Backup path: </div><input :disabled="backUp" style="margin-left: 5px; width: calc(100% - 10px);" placeholder="please select backup folder" class="form-control form-control-sm" v-model="txt1" >
              </div>
            </div>
          </div>
          <spinner v-if="backUp" class="loadSpinner"></spinner>
          <div class="buttons">
              <button :disabled="backUp" class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
              <button :disabled="backUp" class="btn btn-primary" v-on:click="RestoreDb(state.active_db, txt1)">Restore</button>
          </div>
        </div>
      </modal>
      <modal name="db-info" :clickToClose="false" :height="230">
        <div class="modal-header">
          <h3 class="modal-title">Database info</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edge">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Name: {{txt3}}</div>
              </div>
              <div class="edit-line">
                <div class="label-for-input">Port: {{txt2}}</div>
              </div>
              <div class="edit-line">
                <div class="label-for-input">
                  <p>Version<br>
                    <span class="txt-version">Database: {{txt1}},</span><br>
                    <span class="txt-version">NBAdmin: {{state.NBAdmin}} {{state.trial ? "(trial)" : ""}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons">
              <button class="btn btn-secondary" v-on:click="CloseDialog()">Ok</button>
          </div>
        </div>
      </modal>
      <modal name="contacts" :clickToClose="false" :height="230">
        <div class="modal-header">
          <h3 class="modal-title">Contacts</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edge">
            <div>
              <div class="edit-line">
                <div class="label-for-input">Email: support@nitrosbase.com</div>
              </div>
            </div>
          </div>
          <div class="buttons">
              <button class="btn btn-secondary" v-on:click="CloseDialog()">Ok</button>
          </div>
        </div>
      </modal>
      <modal name="start-port" :clickToClose="false">
        <div class="modal-header">
          <h3 class="modal-title">Start</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="modal-body">
          <div class="add-edit-server">
            <div class="edit-line">
              <div class="label-for-input">Port: </div><input type="number" @click="selectAllinput($event)" v-model="txt2" :class="'form-control' + (txt2_invalid?' is-invalid' :'')">
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="btn btn-secondary" v-on:click="CloseDialog()">Cancel</button>
          <button class="btn btn-primary">ok</button>
        </div>
      </modal>
      <!-- <div v-if="loading" class="loading">
        <spinner></spinner>
      </div> -->
      <input id="file-input" type="file" v-on:change="FileSelected" accept="application/sql,text/sql,text/x-sql,text/plain" name="name" style="display: none;" />
      <input id="file-input2" type="file" v-on:change="FileSelectedBackup" name="name" style="display: none;" />
    <!-- </hsc-menu-style-white> -->
    </hsc-menu-style-black>
    <vue-confirm-dialog></vue-confirm-dialog>
  </v-app>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'vue-select/dist/vue-select.css';
import query from '@/components/query-tab-content';
import { commonMixin } from '@/common.js'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import moment from 'moment'
import Search from '@/components/baseComponents/search.vue';
import JqxTabs from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxtabs.vue';
import spinner from '@/components/baseComponents/spinner.vue';
import VirtualList from 'vue-virtual-scroll-list'
import Item from '@/components/baseComponents/itemComponent.vue'
import edgeComp from '@/components/baseComponents/edgeComp.vue';
import JqxScrollBar from "jqwidgets-scripts/jqwidgets-vue/vue_jqxscrollbar.vue";
import LeftMenu from "@/components/left-menu.vue";

export default {
  name: "Home",
  mixins: [commonMixin],
  components: {
    Splitpanes, Pane, query, Search, JqxTabs,spinner,
    'virtual-list': VirtualList,
    JqxScrollBar,
    LeftMenu,
    aceeditor: require('vue2-ace-editor'), 
  },
  mounted(){ 
    // console.log('Home mount', this.state.openedtabs);      
    // this.$refs.scrollbar.theme = 'new'
    this.itemShowEnd = Math.floor(this.$refs.menu.clientHeight/20)
    this.state.height = window.innerHeight - 29 - 40
    this.state.gridWidth = window.innerWidth*0.87 - 5
    window.addEventListener('onbeforeunload', (event)=>{
      event.preventDefault();
    });
    this.height = window.innerHeight - 29 - 40 - 2
  },
  created(){
    console.log('created');  
    // Проверяем, было ли закрытие браузера
    //this.checkBrowserClose();
    this.state.token = sessionStorage.getItem('authToken');  
    // this.state.token = localStorage.getItem('authToken');  
    window.hostname={};
    window.hostname.hasGuid = false
    window.hostname.baseUrl = this.baseUrl;
    window.hostname.idconnect = null    
    let arr2 = []
    // for (const [key, value] of Object.entries(sessionStorage)) {
    for (const [key, value] of Object.entries(localStorage)) {
      if (key != 'active' && key != 'authToken') {
        console.log('created active');        
        arr2.push({key:key, val: JSON.parse(value)})
      }
    }
    let active
    // console.log('created 2 arr2', arr2);
    // if (sessionStorage.length > 0) {
    if (localStorage.length > 0) {
      active = localStorage.getItem('active'); 
    }
    window.addEventListener('beforeunload', this.handler)
    this.LoadDBListFromServer();
    let arr = []  
    
    // for (const [key, value] of Object.entries(sessionStorage)) {
    for (const [key, value] of Object.entries(localStorage)) {
      if (key != 'active' && key != 'authToken') {
        // console.log('created 3');        
        arr.push({key:key, val: JSON.parse(value)})
      }
    }
    let check = setInterval(() => {
      // if (this.state.openedtabs) {
      // }
      if (this.state.guid) {
        clearInterval(check)
        if (arr.length == 0) {
          this.createIdconnect(this.state.openedtabs[0])          
          this.state.active_tab = this.state.openedtabs[0]
          // console.log('cr if: ',this.state.active_tab);     
          this.state.active_tab.editor.focus()     
        } else if (arr.length == 1) {
          // console.log('cr else if: ',arr);
          arr.sort((a,b)=>a.key-b.key);      
          arr.forEach((el,i) => {
            const query = el.val
            this.state.openedtabs[0].query = query            
            this.createIdconnect(this.state.openedtabs[0]) 
            this.state.active_tab = this.state.openedtabs[0]   
          })
        } else {          
          arr.sort((a,b)=>a.key-b.key);      
          arr.forEach((el,i) => {          
            const query = el.val
            if (i == 0) {
              this.state.openedtabs[0].query = query
              this.createIdconnect(this.state.openedtabs[0]) 
            } else {
              this.CreateTab(`Query ${i+1}`,query)
            }
            this.state.active_tab = this.state.openedtabs[active-1]
            // console.log('cr else: ',this.state.active_tab)
            //this.state.active_tab.editor.focus()
          })
        }
        //console.log('this.state.height', window.innerHeight - 29 - 40 -48);
        //this.state.height = window.innerHeight - 29 - 40 - 48
      }  
      // this.getArr()  
    }, 100);
    window.addEventListener("resize", this.myEventHandler);
    this.height = window.innerHeight - 29 - 40 - 2

    // sessionStorage.clear()
    sessionStorage.setItem('authToken', this.state.token);
    this.$on('Refresh', (i) => {
      this.LoadDbFromServer(i)
    })
    this.$on('Stop', (i) => {
      this.StopDb(i)
    })
    this.$on('Start', (i) => {
      console.log('Cr Start');
      this.StartDb(i)
    })
    this.$on('Backup', (i) => {
      this.OpenBackupDialog(i)
    })
    this.$on('Restore', (i) => {
      this.OpenRestoreDialog(i)
    })
    this.$on('DeleteDb', (i) => {
      this.DeleteDb(i)
    })
    this.$on('Database info', (i) => {
      this.OpenDbInfoDialog(i)
    })
    this.$on('CreateTbl', () => {
      this.EditTable(this.state.active_db, null)
    })
    this.$on('Select top 1000', (i) => {
      this.SelectTop1000(i)
    })
    this.$on('Modify structure', (i) => {
      this.EditTable(this.state.active_db,i.name)
    })
    this.$on('Create table', (i) => {
      this.ScriptCreateTbl(i)
    })
    this.$on('DeleteTbl', (i) => {
      this.DeleteTable(i)
    })
    this.$on('CreateInd', (i) => {
      this.OpenCreateIndexDialog(this.state.active_db, i)
    })
    this.$on('DeleteInd', (i,a) => {
      this.DeleteIndex(this.state.active_db,i,a)
    })
    this.$on('Monitoring', () => {
      this.OpenMonitor()
    })    
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload');
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  data: () => ({
    browserClosed: false,
    scrollKey: 0,    
    itemShowEnd: null,
    itemComponent: Item,
    itemComponentEdge: edgeComp,
    items:null,
    lftM: 0,
    state: {
      queryNumber: 0,
      token: null,
      active_db: null,
      active_tab:null,
      active_tab_idx:0,
      active_tbl:null,
      dblist: null,
      //add idconnect
      openedtabs:[{active:true, name:'Query 1', query: '', result: null, resulttext: '', status: '', type: 'query', idconnect: null, resultMulti: [], error: false,}],
      menudb:null,
      menuList:[],
      menuList2: [],
      NBAdmin: '8.0.59(1_f31004e)',                                
      version: '',
      gridWidth: null,
      height: null,
      trial: null,
      guid: null,
      dark: false    
    },
    arrMenu: [],
    dbPort: false,
    search: false,
    keySearch: 'searchAll',
    keyQ: 0,
    startDb: null,
    loading: false,
    noloading: false,
    txt0:'',
    txt0_invalid: false,
    txt1:'',
    txt1_invalid: false,
    txt2:0,
    txt2_invalid: false,
    txt3:'',
    txt3_invalid: false,
    txt4:'',
    txt5: [],
    width: 9,
    height: null,
    min: 0,
    max: 0,
    scrollPos: 0,
    scrollPosOld: -1,
    itemShowBegin: 0,
    itemShowBeginOld: -1,
    elNum : 0,
    backUp: false,
  }),
  computed: {
    hQuery() {
      //console.log('comp app hQuery', this.state.height - 48)
      return this.state.height - 48
    },
    wQuery() {
      //console.log('comp app wQuery', this.state.gridWidth)
      return this.state.gridWidth
    },
    heightScroll() {
      //console.log('heightScroll', window.innerHeight - 29 - 40 -2)
      return window.innerHeight - 29 - 40 - 2
    },    
  },
  methods: {  
    cancelRequest() {
      console.log('cancelRequest', this.state.active_tab.status);
      // this.state.queryNumber++
      this.state.active_tab.status = "Query stopped"
      axios
				.post(this.baseUrl + "/api3", {
				// .post("/api3", {
					cmd: 12,
					idconnect: this.state.active_tab.idconnect,
					guid: this.state.guid,
					token: this.state.token,
          queryNumber: this.state.queryNumber
					// signal: this.state.controller.signal
				}).then(response => {
          console.log('cancelRequest2',response);          
        }).catch((error) => {
          console.log(error);          
        })
    },
    handleStateUpdate(updatedData){
      this.$set(this.state, 'dblist', updatedData.dblist);
      this.$set(this.state, 'menuList2', updatedData.menuList2);
      if (!updatedData.active_db) {
        console.log('updatedArray',this.state.active_db);  
        this.$set(this.state, 'active_db', null);
        this.$set(this.state, 'menudb', null);
        
      }
      this.$nextTick(() => {
        if (this.$refs.leftMenu) {
            this.$refs.leftMenu.getArr?.();
        }
      });    
      // this.$refs.leftMenu.getArr()
    },
    toggleDarkTheme() {
      this.state.dark = !this.state.dark
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      console.log('Dark', this.state.active_tab.editor);
    },
    getDbName(obj) {
      if (obj.hasOwnProperty('parent')) {
        if (obj.parent.type === 'lvl1') {
          this.state.menudb = obj.parent.name
          let db = this.state.dblist.find(el => el.port === obj.parent.port)
          //console.log('getDbName', db)
          this.SetActiveDb(db);
        }
        else this.getDbName(obj.parent)
      }
      //if (obj.childs && obj.childs.length > 0) {
      //  obj.childs.forEach(el => this.expndeAll(el))
      //}
      },
    updateParentY(el,int,bool) {
      if (!el.expanded) {
        console.log('updateParentY', el)
        el.y = 1
      } else {
        bool ? el.y += int : el.y -= int
      }
      //console.log('updateParentY has', el.hasOwnProperty('parent'))
      el.hasOwnProperty('parent') ? this.updateParentY(el.parent,int,bool) : ''
    },
    classGet(el) {      
      let str = ''
      if (el.type == 'lvl1') {
        if (el.expanded) {
          str += 'db expanded '
        } 
        if (!el.expanded) {
          str += 'db collapsed '
        } 
        //if (!el.port) {
        //  str += 'portBusy '
        //}
        if (!el.run) {
          str += 'stop'
        }
      }
      if (el.type == 'lvl2' || el.type == 'lvl3' || el.type == 'lvl4') {        
        if (el.expanded) {
          str += 'db expanded '
        }
        if (!el.expanded) {
          str += 'db collapsed '
        }
      }
      if (el.type == 'lvl5' && !el.fld) {
        //console.log('class', el)
        if (el.expanded) {
          str += 'db expanded '
        }
        if (!el.expanded) {
          str += 'db collapsed '
        }
      }
      
      return str
    },    
    virtualListHeight(db) {      
      let height = db.data.length*22.5
      let tbls = db.data.filter(i => i.expanded)
      let fldHeight = tbls.reduce((sum,current) => sum + 2*22.5,0)
      height += fldHeight
      
      let tblsCol = tbls.filter(i => i.expanded_columns)
      // console.log('virtualListHeight fld: ',tblsCol);
      let colHeight = tblsCol.reduce((sum,current) => sum + current.fields.length*19.5,0)
      // console.log('virtualListHeight: ',height,colHeight);
      height += colHeight
      let tblsIndx = tbls.filter(i => i.expanded_indices)
      let indHeight = 0
      
      if (tblsIndx.length>0) {        
        tblsIndx.forEach(i => {
          let idxlist = db.indexes.filter(it => it.table == i.tablename)
          let indField = idxlist.filter(i => i.expanded)
          let indFldHeight = indField.reduce((sum,current) => sum + current.fields.length*19.5,0)
          indHeight += idxlist.length*22.5
          indHeight += indFldHeight
        })
        height += indHeight
      }
      
      let maxHeight = this.$refs.menu.clientHeight - this.state.dblist.length*22.5 + 2*22.5 - 92
      // console.log('virtualListHeight Max: ',maxHeight);
      if (height < maxHeight) {
        return height
      } else {
        return maxHeight
      }
      
    },
    virtualListHeightEdge(db) {
      let height = db.length*22.5
      if (height < 360) {
        return height
      } else {
        return 360
      }
    },
    checkhasGuid() {
      // let intervalCheck = setInterval(() => {
        if (window.hostname.hasGuid) {          
          return true
        } 
      // }, 100);
    },   
    typePrecision(fld) {
      //console.log('typePrec ');     
      let val = ''
      let type = this.typemap[fld.type+'-'+fld.subtype]
      
      if (fld.precision != 0 && fld.precision != -1) {
        switch (fld.type) {
          case 12:
            val = ` (${fld.precision},${fld.scale}) `
            break;
            
          case 5:
            type = 'datetime'
            val = ` (${fld.precision}) `           
            break;

          default:
            val = ` (${fld.precision}) `
            break;
        }        
      } else if (fld.precision == -1) {
        val =` (max) `
      } 
      let str =  '[' + type + val +','+(fld.nullable === 1?'':' NOT')+' NULL]'||(fld.type+'-'+fld.subtype) + ']' + ' ' + fld.linktable 
      //console.log('str ', str);  
      return str
    },
    selectAllinput(event) {
      console.log('input');
      event.target.select()
    },
    scrollNone(target) {
      switch (target) {
        case 'lvl2Scroll':
          if (this.$refs[target]) {
            this.$refs[target][0].style.overflowY = ''
          }
          if (this.$refs['lvl4Scroll']) {
            this.$refs['lvl4Scroll'][0].style.overflowY = ''
          }
          break;
        case 'lvl4Scroll':
          if (this.$refs[target] && this.$refs['lvl2Scroll']) {
            this.$refs['lvl2Scroll'][0].style.overflowY = 'scroll'
            this.$refs[target][0].style.overflowY = ''
          }
          break;
      
        default:
          break;
      }
    },
    scrollVisible(target) {
      switch (target) {
        case 'lvl2Scroll':
          if (this.$refs[target]) {
            // console.log('vis1', event.target.parentElement.className);
            let parent = event.target.parentElement
            do {
              parent = parent.parentElement
              console.log('vis1', parent,target);
            } while (event.target.parentElement.className ==  target);
            this.$refs[target][0].style.overflowY = 'scroll'
          }
          break;
        case 'lvl4Scroll':
          if (target && this.$refs[target]) {
            this.$refs[target][0].style.overflowY = 'scroll'
          }
          if (this.$refs['lvl2Scroll']) {
            this.$refs['lvl2Scroll'][0].style.overflowY = ''
          }
          break;
      
        default:
          break;
      }
      // if()
    },   
    myEventHandler(e) {
      // console.log('myEventHandler',this.state.height)
      this.state.gridWidth = window.innerWidth * 0.87 - 5
      this.state.height = window.innerHeight - 29 - 40     
      this.height = window.innerHeight - 29 - 40 - 2      
    },
    viewSearch() {
      console.log('viewSearch', this.state.menuList2);
      if (!this.search) {
        this.search = true
      } else {
        this.search = false
      }

    },
    closeS(val) {
      this.search = val
    },
    getWidth() {
      this.state.gridWidth = this.$refs.rightPane.clientWidth
      // console.log('getWidth',this.state.gridWidth);
      // console.log('getWidth',this.$refs.menu.clientHeight);
    },
    filterMenu() {
      console.log('filter');
      // if (data == '') {
      //   return this.state.menuList = this.state.dblist
      // }
      // this.state.menuList = data;
      this.$modal.show('search');
    },
    showSearch() {
      console.log('filter');
      this.$modal.show('search');
    },
    ToggleName(db) {
      // console.log('ToggleName');
      this.state.menudb = db.dbname;
      this.SetActiveDb(db);
    },
    setFocus(selector) {
      // console.log('setFocus');
      setTimeout(function(){
        document.querySelector(selector).focus();
      },50)
    },
    //sent id to destroy when window close
    handler() {
      console.log('handler');
      let nums = []
      // Object.keys(sessionStorage).forEach(key => {
      //   if (key != 'authToken') {
      //     sessionStorage.removeItem(key);
      //   }
      // });
      
      Object.keys(localStorage).forEach(key => {
        if (key != 'authToken') {
          localStorage.removeItem(key);
        }
      });
      this.state.openedtabs.forEach(element => {
        nums.push(element.idconnect)   

        if (element.query) {
          console.log('handler',element.query);          
          const parsed = JSON.stringify(element.query);
          let num =  element.name.split(' ')[element.name.split(' ').length-1]
          if (element.query != "")  {
            // sessionStorage.setItem(`${num}`, parsed)          
            localStorage.setItem(`${num}`, parsed)          
          }
        }
      });      
      let activeNum =  this.state.active_tab.name.split(' ')[this.state.active_tab.name.split(' ').length-1]
      if (activeNum) {        
        // sessionStorage.setItem('active',activeNum)
        localStorage.setItem('active',activeNum)

      }
      // console.log('closeIdconnect',nums);
      axios.post(this.baseUrl + "/api3", {cmd:14,nums, guid:this.state.guid, token: this.state.token}).then(response => {
        console.log('response',response);
        if (response.data.err == 401) {
          sessionStorage.removeItem("authToken")
          this.$router.push('/login');
        }        
      }).catch((error) => {
        console.log('handler',error.message);
      }); 
      // localStorage.clear()
    },
    LoadDBListFromServer(){
      console.log('LoadDBListFromServer');
      this.ExecCommand(7,(response) => {
      // this.ExecCommand(65,(response) => {
        this.state.dblist = response.data.list;
        this.state.menuList2 = []
        response.data.list.forEach( el => {
          this.state.menuList2.push({
            name: el.dbname,
            y: 1,
            expanded: false,
            type: 'lvl1',
            expandedY: 2,
            choseEl: false,
            run: el.run,
            port: el.port,
            dbpath: el.dbpath
          })  
        })        
        this.state.trial = response.data.trial
        this.state.guid = response.data.guid
        window.hostname.hasGuid = true
        if (this.$refs.leftMenu) {						
						this.$refs.leftMenu.getArr()
					}
      });    
    },
    GetIndexListForTable(port, table){
      var idxlist = [];
      for (let i = 0; i < this.state.dblist.length; i++) {
        const db = this.state.dblist[i];
        if(port === db.port){
          for (let j = 0; j < db.indexes.length; j++) {
            const index = db.indexes[j];
            if (index.table === table){
              idxlist.push(index);
            }
          }
          break;
        }
      }
      // console.log('GetIndexListForTable',idxlist);
      return idxlist;
    },   
    ToggleNode(n){   
      console.log('ToggleNode', n);   
      if(!n.run) return;
      this.SetActiveDb(n);
      this.$set(n,'expanded', !n.expanded);
      // if(n.expanded && !n.loaded){
        // console.log('ToggleNode');
      this.LoadDbFromServer(n); 
      
      // let check = setInterval(()=> {
      //   if(n.childs) {
      //     clearInterval(check)
      //     this.getArr(n)
      //   }
      // },10)    
    },
    OpenTab(tab){      
      // debugger
      console.log('OpenTab',tab);      
      for (let i = 0; i < this.state.openedtabs.length; i++) {
        const tab2 = this.state.openedtabs[i];
        tab2.active = false;
        if(tab == tab2) {
          // console.log('OpenTab if1');
          this.state.active_tab_idx = i;
          tab.active = true;
        }
      }
      this.state.active_tab = tab;
      // let idx = this.state.openedtabs.indexOf(tab);
      console.log('OpenTab this.items',this.items);
      let focusInter = setInterval(() => {
        if (this.state.active_tab && this.state.active_tab.editor) {
          clearInterval(focusInter)
          this.state.active_tab.editor.focus()
          this.items = this.state.openedtabs.indexOf(this.state.active_tab)
        }
      }, 10);
      // console.log('OpenTab',this.state.active_tab.editor);
      // this.state.active_tab.editor.focus()
    },
    CreateTab(name, content){
      // sessionStorage.setItem('active', this.state.openedtabs.length+1)
      if(!name){
        console.log('CreateTab name',name);
        let max_query_num=0;
        // console.log('CreateTab name',this.state.openedtabs.length);
        if (this.state.openedtabs.length == 0) {
          name = 'Query '+1;
        }
        for (let i = 0; i < this.state.openedtabs.length; i++) {
          const tab = this.state.openedtabs[i];
          tab.active = false;
          if(tab.name.indexOf('Query ') === 0){
            let n = +tab.name.substring(6);
            if(!isNaN(n) && max_query_num < n)
            {
              max_query_num=n;
            }
          }          
          name = 'Query '+(max_query_num+1);
        }
       
      }else{
        if(this.state.active_tab) this.state.active_tab.active = false;
      }
      if(!content) content = '';      
      let tab = {
        name: name,
        active: true,
        type: 'query',
        query:content,
        resultMulti: [],
        result:null,
        data:null,
        fields:null,
        resulttext:'',
        status:'',
        timespent:-1,
        editor: null,
        //get idconnect
        idconnect: null
      };    
      this.createIdconnect(tab)
      let inter = setInterval(() => {
        if (tab.idconnect >= 0) {
          clearInterval(inter)
          this.state.openedtabs.push(tab);          
          this.state.active_tab = tab;
          this.state.active_tab_idx = this.state.openedtabs.length-1;      
          this.items = this.state.openedtabs.length-1; 
          if (window.hostname) {
            window.hostname.idconnect = tab.idconnect
            window.hostname.fields = []
            // window.hostname.baseUrl = this.baseUrl
            window.hostname.width = this.state.gridWidth
          }
          return 1     
        }
        console.log('CreateTab', this.items)
      }, 10)
      let focusInter = setInterval(() => {
        if (this.state.active_tab.editor) {
          clearInterval(focusInter)
          this.state.active_tab.editor.focus()
        }
      }, 100);
      // console.log('CrTab',this.state.active_tab.editor);
    },   
    Click(id){
      document.getElementById(id).click();
    },
    CloseTab(tab){
      let idx = this.state.openedtabs.indexOf(tab);
      console.log('CloseTab');
      // console.log(sessionStorage,tab.idconnect);
      if(tab === this.state.active_tab){
        console.log('CloseTabIf1Index',idx);
        console.log('CloseTabIf1Length',this.state.openedtabs.length);
        if(idx+1<this.state.openedtabs.length){
          console.log('Close if1_1');
          this.OpenTab(this.state.openedtabs[idx]);
          } else {
          if(idx > 0){
            console.log('Close if1-2-1');
            this.OpenTab(this.state.openedtabs[idx-1]);            
          } else {
            this.state.active_tab = null;
            console.log('Close if1-2-else',this.state.openedtabs);
            this.OpenTab(this.state.openedtabs[idx]);
            this.createIdconnect(this.state.openedtabs[idx])
          }
        }       
      }
      // console.log('CloseTab afterif');
     
      this.state.openedtabs.splice(idx,1);
      
      
      if (this.state.openedtabs.length == 0) {
        console.log('Close if2');
        this.closeIdconnect(tab)
        this.CreateTab();
      } else {
        console.log('Close if3', idx, this.state.openedtabs);
        if (idx === 0) {
          this.OpenTab(this.state.openedtabs[idx]);
          this.closeIdconnect(tab)
        } else {
          this.OpenTab(this.state.openedtabs[idx-1]);
          this.closeIdconnect(tab)
        }
      }      
    },
    SelectTop1000(tbl,name) {      
      if(!name){
        let max_query_num=0;
        // console.log('CreateTab name',this.state.openedtabs.length);
        if (this.state.openedtabs.length == 0) {
          name = 'Query '+1;
        }
        for (let i = 0; i < this.state.openedtabs.length; i++) {
          const tab = this.state.openedtabs[i];
          tab.active = false;
          if(tab.name.indexOf('Query ') === 0){
            let n = +tab.name.substring(6);
            if(!isNaN(n) && max_query_num < n)
            {
              max_query_num=n;
            }
          }          
          name = 'Query '+(max_query_num+1);
        }
       
      }else{
        if(this.state.active_tab) this.state.active_tab.active = false;
      }
      // if(!content) content = '';      
      let tab = {
        name: name,
        active: true,
        type: 'query',
        query:'',
        resultMulti: [],
        result:null,
        data:null,
        fields:null,
        resulttext:'',
        status:'',
        timespent:-1,
        editor: null,
        //get idconnect
        idconnect: null
      };    
      this.createIdconnect(tab)
      // console.log('SelectTop1000 id', tab.idconnect);

      let inter = setInterval(() => {
        if (tab.idconnect) {
          // console.log('SelectTop1000 id 2', tab.idconnect);
          clearInterval(inter)
          if (window.hostname) {
            window.hostname.idconnect = tab.idconnect
            window.hostname.fields = []
            // window.hostname.baseUrl = this.baseUrl
            window.hostname.width = this.state.gridWidth
          }     
          this.state.openedtabs.push(tab);
          this.state.active_tab = tab;
          this.state.active_tab_idx = this.state.openedtabs.length-1;      
          this.items = this.state.openedtabs.length-1; 
          this.state.active_tab.query = "SELECT TOP 1000 * FROM " + '['+tbl.name+']' + ";";
          this.RunActiveTab();
          console.log('SelectTop1000',this.items);
        }
      }, 10)
      // console.log('SelectTop1000 id', this.state.active_tab.idconnect);
      // console.log('SelectTop1000 q', this.state.active_tab.query);
      // let timerId = setInterval(() => {
      //   if (this.state.active_tab.idconnect) {
      //     clearInterval(timerId)
      //     this.state.active_tab.query = "SELECT TOP 1000 * FROM " + '['+tbl.name+']' + ";";
      //     this.RunActiveTab();
      //     // if (this.state.active_tab.idconnect) {
      //     // }
      //   }
      // }, 10);
    },
    ScriptCreateTbl(tbl,name){      
      // this.CreateTab();
      if(!name){
        let max_query_num=0;
        // console.log('CreateTab name',this.state.openedtabs.length);
        if (this.state.openedtabs.length == 0) {
          name = 'Query '+1;
        }
        for (let i = 0; i < this.state.openedtabs.length; i++) {
          const tab = this.state.openedtabs[i];
          tab.active = false;
          if(tab.name.indexOf('Query ') === 0){
            let n = +tab.name.substring(6);
            if(!isNaN(n) && max_query_num < n)
            {
              max_query_num=n;
            }
          }          
          name = 'Query '+(max_query_num+1);
        }
       
      }else{
        if(this.state.active_tab) this.state.active_tab.active = false;
      }
      let tab = {
        name: name,
        active: true,
        type: 'query',
        query:'',
        resultMulti: [],
        result:null,
        data:null,
        fields:null,
        resulttext:'',
        status:'',
        timespent:-1,
        editor: null,
        //get idconnect
        idconnect: null
      }; 
      this.createIdconnect(tab)
      // console.log('ScriptCreateTbl id', tab.idconnect);
      let timerId = setInterval(() => {
        if (tab.idconnect) {
          clearInterval(timerId)
          this.state.openedtabs.push(tab);
          this.state.active_tab = tab;
          this.state.active_tab_idx = this.state.openedtabs.length-1;      
          this.items = this.state.openedtabs.length-1;
          let col = ""
          let flds = tbl.childs[0].childs
          flds.forEach((i,ind) => {
            // console.log('ScriptCreateTbl1', i);
            let str = ""
            let nameType
            switch (i.fld.type) {
              case 1:
                nameType = `[${i.name}] varchar`
                break;
              case 2:
                nameType = `[${i.name}] int`
                break;
              case 3:
                nameType = `[${i.name}] bigint`
                break;
              case 4:
                nameType = `[${i.name}] double`
                break;
              case 5:
                nameType = `[${i.name}] datetime`
                break;
              case 6:
                nameType = `[${i.name}] bit`
                break;
              case 7:
                nameType = `[${i.name}] date`
                break;
              case 9:
                if (i.fld.scale == 1) {
                  nameType = `[${i.name}] binary`
                } else {
                  nameType = `[${i.name}] varbinary`                  
                }
                break;
              case 10:
                // console.log('ScriptCreateTbl2',i.fld.scale);
                if (i.fld.scale == 1) {
                  nameType = `[${i.name}] nchar`
                } else {
                  nameType = `[${i.name}] nvarchar`
                }
                break;
              case 11:
                nameType = `[${i.name}] rowversion`
                break;
              case 12:
                nameType = `[${i.name}] decimal`
                break;
            }            
            if (i.fld.type === 12) {
              nameType += `(${i.fld.precision},${i.fld.scale})`
            } else if (i.fld.type === 5 ) {
              nameType += `(${i.fld.precision})`
              /*
              if(i.precision == 7) {
                nameType += `(${i.precision})`
              } else if (i.precision == 3) {
                nameType += ''
              }
              */ 
            } else {
              if (i.fld.precision === -1) {
                nameType += `(max)`              
              } else {
                if (i.fld.precision == 0) {
                  nameType += ''
                } else {
                  nameType += `(${i.fld.precision})`
                }
              }
            }          
            if (i.fld.nullable == 0) {
              nameType += ' NOT NULL'   
            } else {
              nameType += ' NULL'    
            }            
            let dVal = ''
            if(i.fld.defaultvalue) {
              console.log('scrCr 0',i.fld.type);
              switch (i.fld.type) {
                case 5 :
                  // console.log('scrCr5',i.fld.type);
                  dVal = ` DEFAULT '${i.fld.defaultvalue}'`
                  break; 
                case 7 :
                  // console.log('scrCr7',i.fld.type);
                  dVal = ` DEFAULT '${i.fld.defaultvalue}'`
                  break; 
                case 10 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 12 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 2 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 3 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 4 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 9 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                case 6 :                
                  // console.log('scrCr10',i.fld.type);
                  dVal = ` DEFAULT N'${i.fld.defaultvalue}'`
                  break;              
                default:
                  break;
              }
            }
            
            // str += dVal
            // str += i.fld.defaultvalue ? ` DEFAULT '${i.fld.defaultvalue}'`: ''
            let PK = ""
            let FK = ""         
            switch (i.fld.subtype) {
              case 1:
                PK = ' PRIMARY KEY'
              break;  
              case 2:
                FK = ` FOREIGN KEY([${i.fld.name}]) REFERENCES [${i.fld.linktable}]`
              break;  
            }       
             
            if (str)  {
              if (PK) {
                str += `${nameType}${PK}${dVal}`            
              } else {str += `${nameType}${dVal},${FK}`}             
            } else { 
              if (PK) {
                str = `${nameType}${PK}${dVal},`} else {str = `${nameType}${dVal},${FK}`}                    
            } 
            if (i.fld.increment > 0) {
              let arr = str.split(' ')
              let lastEll = arr[arr.length -1].split('')
              if (lastEll[lastEll.length-1] == ',') {
                lastEll.splice([lastEll.length-1],0,` IDENTITY(${i.fld.seed},${i.fld.increment})`)
              }
              arr.splice(arr.length-1,1,lastEll.join(''));
              str = arr.join(' ')
              // console.log('IDENTITY4',str);
            } 
            // else {
            //   str += ` IDENTITY(${i.seed},${i.increment})`            
            // }    
                  
            if (ind != flds.length - 1) {
              if (str[str.length-1] == ',') {
                str += '\n'            
                // console.log('scrCr1',str);
              } else {  
                str += ',\n'}
                // console.log('scrCr2',str);
            }
            if (col) {
              col += str
            } else {
              col = str
            }
          })
          console.log('ScriptCreateTbl', this.items);
          this.state.active_tab.query = `CREATE TABLE [${tbl.name}] (\n${col}\n);`        
        }
      }, 10);

    },
    ScriptCreateEdge(tbl){
      this.CreateTab();
      let col = ""
      const tbl1 = tbl.fields.filter(i => i.name === 'fromid')[0].linktable
      const tbl2 = tbl.fields.filter(i => i.name === 'toid')[0].linktable
      this.state.active_tab.query = `CREATE TABLE [${tbl.tablename}] AS EDGE [${tbl1}] [${tbl2}];`
    },
    SelectTop1000Edges(tbl, db){
      this.CreateTab();
      let arrTab1 = db.data.find(item => item.tablename === tbl.fields[0].linktable);
      let arrTab2 = db.data.find(item => item.tablename === tbl.fields[1].linktable);
      let col1 = arrTab1.fields.find(item => item.subtype === 1);
      let col2 = arrTab2.fields.find(item => item.subtype === 1);
      this.state.active_tab.query = `SELECT TOP 1000 t1.[${col1.name}], t2.[${col2.name}] FROM ` + '['+tbl.tablename+']' + " t JOIN " + '[' + tbl.fields[0].linktable + ']' + ` t1 on t.fromid = t1.[${col1.name}] JOIN ` + '[' + tbl.fields[1].linktable + ']' + ` t2 on t.toid = t2.[${col2.name}];`;
      const parsed = JSON.stringify(`SELECT TOP 1000 t1.[${col1.name}], t2.[${col2.name}] FROM ` + '['+tbl.tablename+']' + " t JOIN " + '[' + tbl.fields[0].linktable + ']' + ` t1 on t.fromid = t1.[${col1.name}] JOIN ` + '[' + tbl.fields[1].linktable + ']' + ` t2 on t.toid = t2.[${col2.name}];`);
        // console.log(parsed);
      //  sessionStorage.setItem(`${this.state.openedtabs[this.state.openedtabs.length-1].idconnect}`, parsed)
      this.RunActiveTab();
    },
    OpenMonitor() {
      console.log('OpenMonitor');      
      let newtab = {
        name: 'Monitoring',
        active: true,
        type: 'monitoring',
        db: '',
        table:'',
        resulttext:'',
        status:'',
        timespent:-1,
        idconnect: null
      };
      this.createIdconnect(newtab)
      let inter = setInterval(() => {
        if (newtab.idconnect >= 0) {
          clearInterval(inter)
          for (let i = 0; i < this.state.openedtabs.length; i++) {
            const tab = this.state.openedtabs[i];
            tab.active = false;
          }
          this.state.openedtabs.push(newtab);
          this.state.active_tab = newtab;
          this.state.active_tab_idx = this.state.openedtabs.length-1;
          this.items = this.state.openedtabs.length - 1
        }
      },100)
    },
    DeleteTable(tbl){
      console.log('DeleteTable',tbl)
      this.$confirm(
        {
          message: `Are you sure to delete table ${tbl.name}?`,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            console.log('state.active_tab.idconnect',this.state.active_tab.idconnect);
            if (confirm) {
              this.ExecScript(this.state.active_db, `DROP TABLE [${tbl.name}]`,
                (response) => {
                  if (!response.data[0].err) this.LoadDbFromServer(this.state.active_db)   
                //console.log('DeleteTable LoadDbFromServer', tbl)                              
                },
                true, this.state.active_tab.idconnect, this.state.guid);
            }
          }
        }
      )
    },
    DeleteIndex(db,idx,i){
      console.log('DeleteIndex', idx,i);
      //this.SetActiveDb(db);
      this.$confirm(
        {
          message: `Are you sure to delete index ${idx.name} from table ${i}?`,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              this.ExecScript(db, `DROP INDEX [${idx.name}] ON [${i}]`, ()=>this.LoadDbFromServer(db),true,this.state.active_tab.idconnect,this.state.guid);
            }
          }
        }
      )
    },
    StopDb(db){
      console.log('StopDb', db);
      if (this.state.trial) {
        this.$confirm(
        {
          message: `В Trial версии остановка базы\n данных приведет к потере данных.\n Нажмите Cancel, если Вы хотите\n сделать backup перед остановкой базы`,
          button: {
            yes: 'Yes',
            no: 'Cancel',
          },
          callback: confirm => {
            if (confirm) {
              this.loading = true
              axios.post(this.baseUrl + "/api3",{"cmd":4,"dbname":db.dbname,"dbpath": db.dbpath,"port":db.port,guid:this.state.guid})
              // axios.post(this.baseUrl + "/jsonapi",{"cmd":35,"port":3020,guid:this.state.guid})
                .then((response) => {
                  if (response.data.err){
                    if (response.data.err === 301) {
                      this.ShowAlert(`Administrative server restarted`)	
                      this.updateIdconnects()				
                    } else {
                      this.ShowAlert(`Error: ${response.data.msg}`);
                      this.loading = false
                    }
                  }else{
                    db.expanded = false;
                    db.run = false;
                    db.loaded = false;
                    //this.LoadDBListFromServer();
                    this.loading = false
                  }
              }).catch((error) => {
                this.ShowAlert(error.message)	
                console.log('StopDb',error.message);
              });
            }
          }
        })
      } else {
        console.log('StopDb 1');       
        this.loading = true
        this.state.active_tab.resultMulti = []
        // this.openedtabs = []
        // this.tab.status = ""
        // this.tab.error = []
        axios.post(this.baseUrl + "/api3",{"cmd":4,"dbname":db.dbname,"dbpath": db.dbpath,"port":db.port,guid:this.state.guid})
        // axios.post(this.baseUrl + "/jsonapi",{"cmd":35,"port":3020,guid:this.state.guid})
          .then((response) => {
            if (response.data.err) {
              console.log('StopDb 2');
              if (response.data.err === 301) {
                console.log('StopDb 2_1');
                this.ShowAlert(`Administrative server restarted`)	
                this.updateIdconnects()				
              } else {
                console.log('StopDb 2_2');
                this.ShowAlert(`Error: ${response.data.msg}`);
                this.loading = false
              }
            } else {
              console.log('StopDb 3');
              db.expanded = false;
              db.run = false;
              db.loaded = false;
              db.expanded = false
              //this.LoadDBListFromServer();
              this.loading = false
              if (this.$refs.leftMenu) {
                console.log('StopDb 3_1');
                // console.log('StopDb', db);
                // console.log('LoadDbFromServer',dbMenu);
                // dbMenu.y = dbMenu.expandedY + dbMenu.childs[0].y
                // this.$refs.leftMenu.updateParentY(dbMenu,int,bool)
                db.expanded = false
                this.$refs.leftMenu.getArr()
              }
              this.LoadDBListFromServer();
              // this.getArr()
            }
        }).catch((error) => {
          console.log('StopDb 4');
        });
      } 
      // if (this.state.menudb) {
      //   console.log('StopDb 5');
      //   this.state.menudb = ''
      //   this.state.active_db = null
      // } 
        // this.confirm('В Trial версии остановка базы данных приведет к потере данных. Нажмите Cancel. если Вы хотите сделать backup перед остановкой базы')
    },
    getStartDb(event) {
      console.log('ev', event);
      this.startDb = event.params.db
    },
    StartDbPort() {
      console.log('StartDbPort', this.startDb);
      axios.post(this.baseUrl + "/api3",{"cmd":1,"port":+this.txt2,dbname:this.startDb.dbname,dbpath: this.startDb.dbpath,guid:this.state.guid})
        .then((response) => {
          if (response.data.err){
            if (response.data.err === 301) {
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else {
              switch (response.data.err) {
                  case 2:
                    // this.$modal.hide('create-database');
                    this.$modal.show('choosePortStart',{ 'db': this.startDb }); 
                    break;
                
                  default:
                    this.ShowAlert(`Error: ${response.data.msg}`);
                    break;
                }
            }
          }else{
            this.LoadDBListFromServer();
            this.CloseDialog();
          }
        }).catch((error) => {
          console.log('StartDbPort',error.message);
        });
    },
    StartDb(db){      
      // if(this.dbOpen) {
      //   this.$modal.show('start-port');
      // }
      console.log('StartDb check', db);
      this.loading = true    
      let name;
      if (db.name) {
        name = db.name
      }  
      if (db.dbname) {
         name = db.dbname
      }
      axios.post(this.baseUrl + "/api3",{"cmd":1,"port":db.port,dbname:name,dbpath:db.dbpath,guid:this.state.guid})
      // axios.post(this.baseUrl + "/jsonapi",{"cmd":32,"port":3020,dbname:name,dbpath:db.dbpath,guid:this.state.guid})
        .then((response) => {
          if (response.data.err) {
            console.log('StartDb1', response);
            if (response.data.err === 301) {
              //console.log('StartDb2', db, ind);
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else if(response.data.err == 0 && response.data.run) {
              console.log('StartDb2', response);
              this.LoadDBListFromServer(db);
            }
            else {
              switch (response.data.err) {
                  case 1:
                    if (response.data.run) {
                      this.LoadDBListFromServer(db);
                    }
                    break;
                  case 2:
                     //console.log('StartDb4', db, ind);
                    // this.$modal.hide('create-database');
                    this.$modal.show('choosePortStart',{ 'db': db }); 
                    this.loading = false
                    break;
                
                  default:
                    //console.log('StartDb6', db, ind);
                    this.ShowAlert(`Error: ${response.data.msg}`);
                    this.loading = false
                    break;
              }
            }
          }else {
            // console.log('StartDb');
            if (this.$refs.leftMenu) {
              
              // console.log('LoadDbFromServer',dbMenu);
              // dbMenu.y = dbMenu.expandedY + dbMenu.childs[0].y
              // this.$refs.leftMenu.updateParentY(dbMenu,int,bool)
              db.expanded = false
              this.$refs.leftMenu.getArr()
            }
            this.LoadDBListFromServer(db);            
            this.loading = false
          }
        }).catch((error) => {
          console.log('StartDb',error.message);
        });
    },
    SetActiveDb(db){
      this.state.active_db = db;
      this.state.menudb =db.dbname;
      // db.loaded = false
    },
    BackupDb(db, path){
      console.log('BackupDb',);
      let name
      if (db.name) {
        name = db.name
      }  
      if (db.dbname) {
         name = db.dbname
      }
      this.loading = true
      this.backUp = true
      // axios.post(this.baseUrl + "/jsonapi",{"cmd":36,"port":3020,"dbname":name,"dbpath":db.dbpath,"backuppath":path,guid:this.state.guid})
      axios.post(this.baseUrl + "/api3",{"cmd":5,"port":db.port,"dbname":name,"dbpath":db.dbpath,"backuppath":path,guid:this.state.guid})
        .then((response) => {
          this.backUp = false
          this.CloseDialog();

          if (response.data.err){
            if (response.data.err === 301) {
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else {
              this.ShowAlert(`Error: ${response.data.msg}`);
              this.loading = false
            }
          }else{
            this.ShowAlert(`Database backup saved!`);
            this.loading = false
          }
        }).catch((error) => {
          this.backUp = false
          this.CloseDialog();
          this.ShowAlert(`Error: ${error.message}`);
          console.log('BackupDb',error.message);
        });
        // this.CloseDialog()
    },
    RestoreDb(db, path) {      
      this.backUp = true
      let name
      if (db.name) {
        name = db.name
      }  
      if (db.dbname) {
         name = db.dbname
      }
      if(!path){
        console.log('RestoreDb1');
        this.ShowAlert(`You should provide backup path!`);
        this.backUp = false
        return;
      }
      console.log('RestoreDb',db, path);
      this.loading = true
      axios.post(this.baseUrl + "/api3",{"cmd":6,"port":db.port,"dbname":name,"dbpath":db.dbpath,"backuppath":path,guid:this.state.guid})
      // axios.post(this.baseUrl + "/jsonapi",{"cmd":37,"port":3020,"dbname":name,"dbpath":db.dbpath,"backuppath":path,guid:this.state.guid})
        .then((response) => {
          this.backUp = false
          this.CloseDialog();
          if (response.data.err){
            if (response.data.err === 301) {
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else {
              const splitErr = response.data.msg.split(':')
              // console.log('restore err', splitErr);
              if (splitErr[0] === 'E201') {
                this.ShowAlert(`Stop ${db.dbname}, before restore`);
                this.loading = false
              } else {
                this.ShowAlert(`Error: ${response.data.msg}`);
                this.loading = false
              }
            }
          }else{
            this.LoadDbFromServer(db)
            // this.LoadDBListFromServer()
            // console.log("restore",this.state);
            let promiseLoad = new Promise ((resolve,promis) => {
              resolve(this.LoadDBListFromServer(db))
            })
            promiseLoad.then(
              result => {
                this.ShowAlert(`Backup restored!`);
                this.loading = false
              },
              error => {
                console.log('PromisErr', error)
                this.loading = false
              }
            )
          }
        }).catch((error) => {
          console.log('RestoreDb',error.message);
          this.backUp = false
          this.CloseDialog();
          this.ShowAlert(`Error: ${error.message}`);
          console.log('BackupDb',error.message);
        });
    },
    DeleteDb(db){
      let name
      if (db.name) {
        name = db.name
      }  
      if (db.dbname) {
         name = db.dbname
      }
      this.$confirm(
        {
          message: `Are you sure to delete database ${db.name}?`,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              axios.post(this.baseUrl + "/api3",{"cmd":10,"port":db.port,"dbname":name,"dbpath":db.dbpath,guid:this.state.guid,token:this.state.token})
              // axios.post(this.baseUrl + "/jsonapi",{"cmd":38,"port":3020,"dbname":name,"dbpath":db.dbpath,guid:this.state.guid})
                .then((response) => {
                  console.log('del', response.data.err);                  
                  if (response.data.err == 401) {
                      sessionStorage.removeItem("authToken")
                      this.$router.push('/login');
                    }
                  if (response.data.err){                    
                    if (response.data.err === 301) {
                      this.ShowAlert(`Administrative server restarted`)	
                      this.updateIdconnects()				
                    } else {                      
                      this.ShowAlert(`Error: ${response.data.msg}`);
                    }
                  } else {
                    this.LoadDBListFromServer();
                    setTimeout(() => {
                      console.log('delete', this.state.dblist);
                      this.ToggleNode(this.state.dblist[0])
                    }, 100);
                    this.ShowAlert(`Database deleted.`);
                    this.CloseDialog();
                  }
                }).catch((error) => {
                  console.log('DeleteDb',error.message);
                });
            }
          }
        }
      )
    },
    CloseDb(db){
      console.log('Close',db);
      this.$confirm(
        {
          message: `Are you sure you want to close the database ${db.dbname}?`,
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              this.loading = true
              axios.post(this.baseUrl + "/api3",{"cmd":4,"port":db.port,"dbname":db.dbname,"dbpath":db.dbpath,guid:this.state.guid})
                .then((response) => {
                  if (response.data.err){
                    if (response.data.err === 301) {
                      this.ShowAlert(`Administrative server restarted`)	
                      this.updateIdconnects()				
                    } else {
                      this.ShowAlert(`Error: ${response.data.msg}`);
                      this.loading = false
                    }
                  }else{
                    this.LoadDBListFromServer();
                    this.ShowAlert(`Database closed.`);
                    this.CloseDialog();
                    this.loading = false
                  }
                }).catch((error) => {
                  console.log('CloseDb',error.message);
                });
            }
          }
        }
      )
    },
    DiagramDb(db){
      console.log('DiagramDb');
      let newtab = {
        name: 'Diagram',
        active: true,
        type: 'diagram',
        db: db,
        resulttext:'',
        status:'',
        timespent:-1,
        idconnect: this.createIdconnect()
      };
      for (let i = 0; i < this.state.openedtabs.length; i++) {
        const tab = this.state.openedtabs[i];
        tab.active = false;
      }
      this.state.openedtabs.push(newtab);
      this.state.active_tab = newtab;
      this.state.active_tab_idx = this.state.openedtabs.length-1;
    },
    EditTable(db, tbl){
           
      let newtab = {
        name: tbl?tbl :'Create table',
        active: true,
        type: 'edit-table',
        db: db,
        table:tbl,
        resulttext:'',
        status:'',
        timespent:-1,
        idconnect: null
      };
      this.createIdconnect(newtab)
      let inter = setInterval(() => {
        if (newtab.idconnect >= 0) {
          clearInterval(inter)
          for (let i = 0; i < this.state.openedtabs.length; i++) {
            const tab = this.state.openedtabs[i];
            tab.active = false;
          }
          this.state.openedtabs.push(newtab);
          this.state.active_tab = newtab;
          this.state.active_tab_idx = this.state.openedtabs.length-1;
          this.items = this.state.openedtabs.length - 1
          console.log('EditTable', this.items); 
        }
      }, 10)
    },
    CreateDatabase(name, theport, path){      
      let error = []
      if(typeof(theport) != 'number') {
        theport = +theport;
      }
      let valid = true;
      if(theport <= 0 || this.txt2 == '' || theport > 65535){
        this.txt2_invalid = true;
        valid = false;
        error.push('Invalid port')
      }
      else {
        this.txt2_invalid = false;
      }
      if(!this.CheckNameIsValid(name) || this.txt1 == ''){
        this.txt1_invalid = true;
        valid = false;
        if (this.txt1 == '') {
          console.log('CreateDatabase ifValid1');
          error.push('Enter database name')
        } else {
          error.push('Invalid database name')
        }
      } else {        
        this.txt1_invalid = false;
      }
      console.log('CreateDatabase',name,theport,path);
      if(valid) {
        this.loading = true
        axios.post(this.baseUrl + "/api3",{"cmd":3,"port":theport,"dbname":name, "dbpath":path,guid:this.state.guid})
        // axios.post(this.baseUrl + "/jsonapi",{"cmd":34,"port":theport,"dbname":name, "dbpath":path,guid:this.state.guid})
          .then((response) => {
            if (response.data.err){
              if (response.data.err === 301) {
                this.ShowAlert(`Administrative server restarted`)	
                this.updateIdconnects()				
              } else {
                switch (response.data.err) {
                  case 1:
                    // this.$modal.hide('create-database');
                    let mesage = response.data.msg.split(': ')[1]
                    this.ShowAlert(`${mesage}`);
                    this.LoadDBListFromServer();
                    this.loading = false
                  // switch (response.data.err) {
                  break;  
                  case 2:
                    this.$modal.hide('create-database');
                    this.$modal.show('choosePort');
                    // this.LoadDBListFromServer();
                    this.loading = false
                  break;
                
                  default:
                    this.ShowAlert(`Error: ${response.data.msg}`);
                    this.loading = false
                    break;
                }
              }
            }else{
              this.LoadDBListFromServer();
              this.CloseDialog();
            }
          }).catch((error) => {
            console.log('CreateDatabase',error.message);
          });
      } else {
        this.ShowAlert(error.join('\n')); 
        return
      }
    },
    OpenDatabase(name,theport,path){
      let error = []
      if(typeof(theport) != 'number')
        theport = +theport;
      let valid = true;
      if(theport <= 0){
        this.txt2_invalid = true;
        valid = false;
        error.push('invalid port')
      }
      else
        this.txt2_invalid = false;
      // if(!this.CheckNameIsValid(name)){
      //   this.txt1_invalid = true;
      //   valid = false;
      //   error.push('invalid name')
      // }
      // else
      //   this.txt1_invalid = false;
      // if(!path){
      //   this.txt3_invalid = true;
      //   error.push('invalid path!')     
      //   valid = false;
      // } else {
      //   this.txt3_invalid = false;
      // }
      if (!valid) {
        this.ShowAlert(error.join()); 
        return;
      }
      this.loading = true 
      axios.post(this.baseUrl + "/api3",{"cmd":1,"port":theport,"dbname":name,"dbpath":path,guid:this.state.guid})
      // axios.post(this.baseUrl + "/jsonapi",{"cmd":32,"port":theport,"dbname":name,"dbpath":path,guid:this.state.guid})
        .then((response) => {
          
          if (response.data.err){
            if (response.data.err === 301) {
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else {
              switch (response.data.err) {
                case 1:
                  console.log('OpenDB');
                  this.$modal.hide('open-database');
                  let mesage = response.data.msg.split(': ')[1]
                  this.ShowAlert(`${mesage}`);
                  this.LoadDBListFromServer();
                  this.loading = false
                  // this.ShowAlert(`Error: ${response.data.msg}`); 
                  break;
                // case 8:
                //   this.$modal.hide('open-database');
                //   // if ("E201: Database is already running on TCP port 3030") {
                //     let mesage = response.data.msg.split(': ')[1]
                //     this.ShowAlert(`${mesage}`);
                //     this.LoadDBListFromServer();
                //   // } else {
                //   //   this.ShowAlert(`Error: ${response.data.msg}`); 
                //   // }
                //   // this.ShowAlert(`Error: ${response.data.msg}`); 
                //   break;
              
                case 2:
                  this.$modal.hide('open-database');
                  this.$modal.show('choosePortOpen');
                  this.loading = false
                  // this.LoadDBListFromServer(); 
                  break;
              
                default:
                  this.ShowAlert(`Error: ${response.data.msg}`);
                  this.loading = false
                  break;
              }              
            }
          }else{
            //console.log('RestoreDb', JSON.stringify(response.data));
            this.LoadDBListFromServer();
            this.$modal.hide('choosePortOpen');
            this.ShowAlert(`Database ${name} has been opened`);
            this.CloseDialog();
            this.loading = false
          }
        }).catch((error) => {
          console.log('OpenDatabase',error.message);
        });
    },
    CreateEdge(name, tbl1, tbl2){
      console.log('CreateEdge');
      let emptyfields = ''
      if (name === '') {
        emptyfields += 'Edge name is empty \n'
      }
      if (tbl1 === '') {
        emptyfields += 'From is empty \n'
      }
      if (tbl2 === '') {
        emptyfields += 'To is empty \n'
      }
      if (emptyfields !== '') {
        this.ShowAlert(emptyfields);
        return false
      }
      this.ExecScript(this.state.active_db, `CREATE TABLE [${name}] AS EDGE [${tbl1}] [${tbl2}];`,response=>{
        if (!response.data[0].err){
          this.LoadDbFromServer(this.state.active_db)
          this.CloseDialog();
        } else {
          this.ShowAlert(`Error: ${response.data[0].msg}`);          
        }
      },true,this.state.active_tab.idconnect,this.state.guid)
    },
    OpenCreateEdgeDialog(db){
      this.SetActiveDb(db);
      this.txt1 = '';
      this.txt3 = '';
      this.txt4 = '';
      this.$modal.show('create-edge');
      this.setFocus('.createEdge')
    },
    format_date(value){
      if (value) {
        // return moment(String(value)).format('YYYY-MM-DD.HH-mm-ss')
        console.log('date',moment().format('YYYY-MM-DD.HH-mm-ss'));
        return moment().format('YYYY-MM-DD.HH-mm-ss')
      }
    },
    OpenBackupDialog(db){
      this.SetActiveDb(db);
      let name;
      if (db.name) {
        name = db.name
      }  
      if (db.dbname) {
         name = db.dbname
      }
      let path= db.dbpath;
      if(!path) {
        console.log('OpenBackupDialog',db);
        this.txt1 = '\\'+name+'.'+this.format_date(new Date());
      } else {
        if( path.endsWith('data')) {}
          path = path.substr(0,path.length - 4) + 'bak';
        this.txt1 = path+'\\'+name+'.'+this.format_date(new Date());
      } 
      this.$modal.show('create-backup');
    },
    OpenRestoreDialog(db){
      this.SetActiveDb(db);
      this.txt1 = '';
      this.$modal.show('create-restore');
    },
    OpenDbInfoDialog(db){
      this.SetActiveDb(db);
      this.txt1 = this.state.version;
      this.txt2 = db.port;
      if (db.dbname) {
        this.txt3 = db.dbname;
      } else {
        this.txt3 = db.name;
      }
      this.txt4 = db.dbpath;
      this.$modal.show('db-info');
    },
    OpenDbContactsDialog(db){
      this.$modal.show('contacts');
    },
    OpenCreateDbDialog(){
      this.txt1 = '';
      this.txt2 = 0;
      this.$modal.show('create-database');
      this.setFocus('.create-db')
    },
    OpenDbDialog(){
      this.txt1 = '';
      this.txt2 = 0;
      this.txt3 = '';
      this.$modal.show('open-database');
      this.setFocus('.create-db')
    },
    OpenCreateIndexDialog(db,tbl){
      console.log('OpenCreateIndexDialog',db,tbl);
      
      this.SetActiveDb(db);
      this.active_tbl = tbl;
      let tabN = {
        name: 'Create index',
        active: true,
        type: 'edit-index',
        table:tbl,
        db:db,
        resulttext:'',
        status:'',
        timespent:-1,
        idconnect: null
      };
      this.createIdconnect(tabN)      
      
      let inter = setInterval(() => {
        if (tabN.idconnect >= 0) {
          clearInterval(inter)
          for (let i = 0; i < this.state.openedtabs.length; i++) {
            this.state.openedtabs[i].active = false;
            // tabN.active = false;
          }
          this.state.openedtabs.push(tabN);
          this.state.active_tab = tabN;
          this.state.active_tab_idx = this.state.openedtabs.length-1;
          this.items = this.state.openedtabs.length - 1
          console.log('OpenCreateIndexDialog', this.items);
        }
      }, 10)
    },
    CloseDialog(){
      this.$modal.hide('create-database');
      this.$modal.hide('open-database');
      this.$modal.hide('create-edge');
      this.$modal.hide('create-backup');
      this.$modal.hide('create-restore');
      this.$modal.hide('db-info');
      this.$modal.hide('contacts');
      this.$modal.hide('start-port');
      this.$modal.hide('search');
      this.$modal.hide('choosePort');
      this.$modal.hide('choosePortStart');
      this.$modal.hide('choosePortOpen');
      this.loading = false
    },
    CancelCreateDb() {
      console.log('CancelCreateDb', this.txt0, this.txt1, this.txt2 );    
      axios.post(this.baseUrl + "/api3",{"cmd":10,"port":+this.txt2,"dbname":this.txt1,"dbpath":this.txt0,guid:this.state.guid,token:this.state.token})
        .then((response) => {
          if (response.data.err){
            if (response.data.err === 301) {
              this.ShowAlert(`Administrative server restarted`)	
              this.updateIdconnects()				
            } else if (response.data.err == 401) {
							sessionStorage.removeItem("authToken")
							this.$router.push('/login');
						} else {
              this.ShowAlert(`Error: ${response.data.msg}`);
            }
          }else{
            // this.LoadDBListFromServer();
            // setTimeout(() => {
            //   console.log('delete', this.state.dblist);
            //   this.ToggleNode(this.state.dblist[0])
            // }, 100);
            // this.ShowAlert(`Database deleted.`);
            // this.CloseDialog();
          }
        }).catch((error) => {
          console.log('DeleteDb',error.message);
        });
    },
    OpenFile(){
      document.getElementById('file-input').click();
    },
    FileSelected(e){
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsText(file,'UTF-8');
      reader.onload = readerEvent => {
        var content = readerEvent.target.result; // this is the content!
        //this.state.active_tab.query = content;
        this.CreateTab(file.name, content);
        //this.state.active_tab.name = file.name;
      }
    },
    FileSelectedBackup(e){
      console.log(e)
      var file = e.target.files[0];
      this.loading = true
      axios.post(this.baseUrl + "/api3",{"cmd":6,"port":this.state.active_db.port,"dbname":this.state.active_db.dbname,"dbpath":this.state.active_db.dbpath,"backuppath":file,guid:this.state.guid})
        .then((response) => {
          if (response.data.err){
            if (response.data.err === 301) {
						this.ShowAlert(`Administrative server restarted`)	
						this.updateIdconnects()				
					} else {
            this.ShowAlert(`Error: ${response.data.msg}`);
            this.loading = false            
          }
          }else{
            // console.log('BackupDb', JSON.stringify(response.data));
            this.ShowAlert(`Backup restored!`);
            this.loading = false
          }
        }).catch((error) => {
          console.log('FileSelectedBackup',error.message);
        });
    },
    stopBrowserMenu(e) {
      // console.log('rClick');
      e.preventDefault()
    },
  },
};
// function ToggleName() {
//   console.log('click');
// }
</script>

<style lang="scss">  
  .closeBtn {
    font-size: 20px !important;
  }
.on-hover {
  color: red !important;
}
.hQuery {
  height: 100%;
}
.loading {
  z-index: 1000;
  top: 0;
  opacity: 0.5;
  position: absolute;
  left: calc(50% - 52px);
  top: calc(50% - 52px)
}
.searchCmp {
  border: none;
}
div.fixed{
  z-index: 8;
}
.portBusy {
  opacity: .65;
  cursor: default;
}
body {
    font-size: 13px;
    color: #555;
}
html, body {
    height: 100%;
    margin: 0;
    overflow-y: auto;
}
.v-system-bar, .v-system-bar2{
  display: flex;
  overflow: hidden;
  height:30px;
  border-bottom: 1px solid #eeeeee;
  //background-color: white;
}
.v-system-bar2{
  background-color: #eeeeee;
  height: 40px;
  margin-top: 0;
}
.v-system-bar2d{
  background-color: rgb(20, 20, 20);
  height: 40px;
  margin-top: 0;
  border-bottom: 1px solid #eeeeee;
}
.v-system-bar span, .v-system-bar2 span, .v-system-bar2d span{
  margin-right: 10px;
  margin-left: 13px;
  font-size: 10pt;
  margin-top: 9px;
  cursor: pointer;
  /* width: 250px; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.cancel {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-system-bar2 > button.panelbutton.roundbtn.cancel > span {
  background: red;
  width: 15px;
  height: 15px;
  display: block;
  border-radius: 2px;
  margin: 0;
}
.toolbar-title{
  font-size: 13pt;
  margin: 0px 10px;
  display: none;
}
.menu{
  // background-color: white!important;
  border-radius: 0px!important;;
}
li{
  list-style-type: none;
  white-space: nowrap;
}
.db{
  cursor: pointer;
  overflow-x: hidden;
}
.collapsed::before{
  content: "+";
  display: inline-block;
  font-style: normal;
  font-size: 15px;
  font-weight: 900;
  color: #326690;
  margin-right: 5px;
  width: 8px;
}
.expanded::before{
  transform: rotate(0deg);
  content: "-";
  display: inline-block;
  font-style: normal;
  font-size: 15px;
  font-weight: 900;
  color: #326690;
  margin-right: 5px;
  width: 8px;
}
.stopped::before{
  content: "";
}
.nested{
  padding-left: 24px;
}
.left-pane-tree-div, .errordiv{
  overflow-y: hidden;
  height: 100%;
}
.left-pane-tree-div::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
.left-pane-tree-div::-webkit-scrollbar-thumb {
    background: #ececec;
    border-radius: 0;
}
.left-pane-tree-div::-webkit-scrollbar-track {
    background: #FFFFFF;
}

.panes-container {
  margin: 0;
  padding: 0;
  height: calc(100% - 30px - 40px);
/*  //height: 100%;*/
  display: flex;
  width: 100%;
  overflow: hidden;
}
.panes-separator, .left-pane, .right-pane {
    margin: 0;
    padding: 0;
    height: 100%;
}
.left-pane {
    position: relative
}
.panes-separator {
  width: 5px;
  border-right: solid 1px lightgray;
  cursor: col-resize;
}
.left-pane-header {
    background-color: rgb(217, 217, 220);
    background-color: #326690;
    color: #dedede;
    height: 28px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    padding-left: 14px;
}


.help-icon::before{
  content: "?";
  display: inline-block;
  font-style: normal;
  font-size: 22px;
  font-weight: 900;
  color: #326690;
  margin-right: 5px;
}
.spacer{
  display: flex;
  flex-grow: 1;
}
.right-pane{
  flex: 1;
}
.div-shift {
    overflow: hidden;
    background-color: rgb(236, 236, 236);
    white-space: nowrap;
    height: 28px;
    width: 100%;
}
.span-close-tab {
    position: absolute;
    margin-left: 4px;
    font-family: "Roboto Mono";
    color: #c8c8c8;
    font-size: 12px;
    display: none;
}
.span-close-tab:hover {
    color: red;
}
.wj-tabheader.wj-state-active .span-close-tab, .wj-tabheader:hover .span-close-tab{
  display: initial;
}
.wj-tabpanel>div>.wj-tabheaders>.wj-tabheader {
    padding: 8px 5px;
    padding-right: 16px;
    font-weight: normal;
}

.modal-header {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #eceeef;
}
.modal-title {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1.2;
    font-size: 1.25rem;
    font-weight: 500;
}
.close {
    float: right;
    font-family: sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
    text-decoration: none;
    cursor: pointer;
}
.modal-body {
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 15px;
}
.vm--modal{
  overflow: initial!important;
  /* height: 400px!important; */
}
.edit-line {
    float: left;
    width: 100%;
}
.edit-line p {
  margin-bottom: 0;
}
.edit-line p .txt-version {
  margin-left: 20px;
}
.edit-line input {
  margin-left: 0px;
}
.add-edit-server .label-for-input, .add-edit-table .label-for-input, .add-edit-index .label-for-input, .add-edit-column .label-for-input, .add-edit-table .label-for-input-primary, .add-edit-table .label-for-input-null, .add-edit-column .label-for-input-primary, .add-edit-column .label-for-input-null, .add-edit-column .label-for-input-foreign-key, .add-edit-table .label-for-input-foreign-key {
    width: 120px;
    float: left;
    margin: 5px;
    padding: 3px;
}
.add-edit-server input, .add-edit-table input, .add-edit-column input, .textbox {
    margin: 5px;
    padding: 5px;
    border-radius: 0;
    border: 1px solid #999999;
    float: left;
}
.add-edit-server input:focus{
    border-radius: 0;
}
.buttons {
    float: right;
    margin-top: 6px;
    text-align: end;
}
.buttons button {
    font-size: 16px;
    padding: 6px;
    margin-left: 6px;
}
.v-select {
    margin: 5px;
}
.panelbutton{
    color: #000;
    opacity: .8;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid black;
    margin: 1px;
}
.roundbtn{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: white;
}
.roundbtn:hover{
  background-color: #ececec;
  border: 1px solid white;
  outline: none;
}
.roundbtn:focus{
  border: 1px solid white;
  outline: none;
}
.roundbtn svg{
  margin-left: -1px;
  margin-top: -4px;
}
.play {
  fill: green;
  margin-left: 2px;
}
.play svg {
  margin-left: 2px;
}

.form-control, .vs__dropdown-toggle{
  border-radius: 0;
}
a[href="https://www.grapecity.com/licensing/wijmo"]{
  display:none;
}
.wj-tooltip{
  display: none;
}
body > div[style*="visibility: visible;"]{
  display: none !important;
}
.treerow{
  white-space: nowrap;
  width: 100%;
  cursor: pointer;
  height: 20px;
}
.treerow:hover{
  background-color: rgba(127, 127, 127, 0.75);
}
.lvl1{
  padding-left: 14px;
  /* overflow-y: scroll; */
}
/* .lvl2Scroll {
  height: 170px;
  overflow: hidden;
}
.lvl4Scroll {
  height: 170px;
  overflow: hidden;
}
.addScroll {
  overflow-y: scroll;
} */
/* .lvl2Scroll::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
.lvl2Scroll::-webkit-scrollbar-thumb {
    background: #ececec;
    border-radius: 0;
}
.lvl2Scroll::-webkit-scrollbar-track {
    background: #FFFFFF;
} */
/* .lvl4Scroll::-webkit-scrollbar {
    padding-left: 6px;  
    width: 6px;
    height: 6px;
}
.lvl4Scroll::-webkit-scrollbar-thumb {
    background: #ececec;
    border-radius: 0;
}
.lvl4Scroll::-webkit-scrollbar-track {
    background: #FFFFFF;
} */
.lvl2{
  padding-left: 27px;
  /* overflow-y: scroll; */
}
.lvl3{
  padding-left: 40px;
}
.lvl4{
  padding-left: 53px;
}
.lvl5{
  padding-left: 66px;
}
.lvl6{
  padding-left: 79px;
}
.menucontainer{
  height: 20px;
}
.menubaritem{
  padding: 4pt 0.5em 4pt 0.5em!important;
}
.wj-tabpanel, .wj-tabpanel>div,div[wj-part="tabpanes"], .wj-tabpane.wj-state-active{
  height: 100%;
}
.wj-tabpanel{
  color: #9fa0a0;
}
.wj-tabpanel>div[_wjsiblingid="1"]{
  height: initial;
}
.splitpanes.default-theme .splitpanes__pane {
    background-color: white;
}
.default-theme.splitpanes--vertical>.splitpanes__splitter, .default-theme .splitpanes--vertical>.splitpanes__splitter {
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
}
.ace_gutter{
  bottom: 1px;
}
.otherinfo{
  color:blueviolet;
}
.btn{
  border-radius: 0;
}
.vc-text {
  white-space: pre;
}
.vc-container {
  width: auto !important;
}
.stop {
  opacity: .5;
}

@function top-shadow($depth) {
  $primary-offset: nth(1.5 3 10 14 19, $depth) * 1px;
  $blur: nth(1.5 3 10 14 19, $depth) * 4px;
  $color: rgba(black, nth(.12 .16 .19 .25 .30, $depth));

  @return 0 $primary-offset $blur $color;
}

/**
 * Computes a bottom-shadow for a card effect.
 *
 * @param {Number} $depth - depth level
 *
 * @return {List}
 */
@function bottom-shadow($depth) {
  $primary-offset: nth(1.5 3 6 10 15, $depth) * 1px;
  $blur: nth(1 3 3 5 6, $depth) * 4px;
  $color: rgba(black, nth(.24 .23 .23 .22 .22, $depth));

  @return 0 $primary-offset $blur $color;
}

/**
 * Gives a card depth effect.
 *
 * @param {Number} $depth - depth level (between 1 and 5)
 *
 * @link https://www.google.com/design/spec/layout/layout-principles.html#layout-principles-dimensionality Google Design
 *
 * @requires {function} top-shadow
 * @requires {function} bottom-shadow
 */
@mixin card($depth) {
  @if $depth < 1 {
    box-shadow: none;
  } @else if $depth > 5 {
    @warn "Invalid $depth `#{$depth}` for mixin `card`.";
  } @else {
    box-shadow: bottom-shadow($depth), top-shadow($depth);  
  }
}
.loadSpinner {
  position: absolute;
  left: calc(50% - 51px);
  top: 35px;
}
.spinner-canvas {  
  width: 100%;
  height: 100%;  
}
.spinner-box {
  display: inline-block;
  overflow: hidden;
  width: 8em;
  height: 8em;
    
  border: 1px solid rgba(black,.1);
  border-radius: 50%;
  background:white;
  @include card(3);
}
.createEdge {
  margin: 5px
}

.block-overflow::-webkit-scrollbar {
  width: 7px;
  background: #eee;
}
</style>
